(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('lang-toggle')) {
    customElements.define(
      'lang-toggle',
      class extends HTMLElement {
        connectedCallback() {
          // Options are server-rendered in Liquid. Section hydration morphs the
          // subtree back to server HTML, so JS-generated children would be wiped
          // — a delegated listener on the host survives that; per-button
          // listeners would not.
          if (!this.clickBound) {
            this.clickBound = true;
            this.addEventListener('click', (event) => {
              const btn = event.target.closest('.lang-toggle__option');
              if (!btn || btn.getAttribute('aria-current') === 'true') return;
              const select = this.querySelector('select[name="language_code"]');
              if (!select) return;
              select.value = btn.dataset.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }
          this.renderFallback();
        }
        renderFallback() {
          // Only rebuild if the server-rendered options are missing.
          const optionsEl = this.querySelector('.lang-toggle__options');
          const select = this.querySelector('select[name="language_code"]');
          if (!optionsEl || !select || optionsEl.children.length > 0) return;
          optionsEl.innerHTML = Array.from(select.options)
            .map(
              (opt) =>
                '<button type="button" class="lang-toggle__option" tabindex="-1" data-value="' +
                opt.value +
                '" aria-current="' +
                (opt.selected ? 'true' : 'false') +
                '">' +
                opt.value.toUpperCase() +
                '</button>'
            )
            .join('<span aria-hidden="true">/</span>');
        }
      }
    );
  }

  // BUCKS kur widget'ı temadaki .buckscc-currency-box'lardan yalnızca BİRİNE
  // mount ediyor (header'daki). Mobilde o slot gizli olduğundan mount edilen
  // widget'ı viewport'a göre doğru slota taşırız (drawer ↔ header). Uygulama
  // async mount ettiği için MutationObserver ile bekleriz.
  (function () {
    var mobileMq = window.matchMedia('(max-width: 749px)');

    function placeCurrencyWidget() {
      var desktopSlot = document.querySelector('.header-currency-slot .buckscc-currency-box');
      var drawerSlot = document.querySelector('.menu-drawer__currency-slot .buckscc-currency-box');
      if (!desktopSlot || !drawerSlot) return;
      // App resize'da rerender edip İKİNCİ bir wrapper mount edebiliyor —
      // en yenisini (DOM'da sonuncu) tut, eskileri kaldır.
      var widgets = document.querySelectorAll('.buckscc-currency-wrapper');
      if (!widgets.length) return;
      var widget = widgets[widgets.length - 1];
      for (var i = 0; i < widgets.length - 1; i++) widgets[i].remove();
      var headerComponent = document.getElementById('header-component');
      var drawerMode = headerComponent && headerComponent.dataset.menuStyle === 'drawer';
      var target = mobileMq.matches || drawerMode ? drawerSlot : desktopSlot;
      if (widget.parentElement !== target) target.appendChild(widget);
      fixAutoLocationLabel();
    }

    // App, konum-bazlı para birimi seçeneğini "Auto Location" diye etiketler ve
    // USD/EUR seçeneklerini "US Dollar (USD)" / "Euro (EUR)" gibi uzun yazar —
    // kullanıcı isteği: kısa kodlar görünsün, TRY yerine TL. Hem açılır liste
    // (.bucksItem) hem seçili değer (.bucks-selected, her zaman sadece kod
    // içerir — TRY/USD/EUR) etiketlenir. Observer app rerender'larında ve
    // kur değişiminde yeniden uygular; eşitlik kontrolü döngüyü keser.
    var CURRENCY_LABELS = { TRY: 'TL', USD: 'USD', EUR: 'EUR' };
    function fixAutoLocationLabel() {
      var items = document.querySelectorAll('.buckscc-select-options li');
      for (var i = 0; i < items.length; i++) {
        var code = items[i].getAttribute('rel') || items[i].id;
        var mapped = CURRENCY_LABELS[code];
        var label = items[i].querySelector('.bucksItem');
        if (mapped && label && label.textContent !== mapped) label.textContent = mapped;
      }
      var selected = document.querySelectorAll('.bucks-selected');
      for (var j = 0; j < selected.length; j++) {
        var mappedSelected = CURRENCY_LABELS[selected[j].textContent.trim()];
        if (mappedSelected && selected[j].textContent !== mappedSelected) {
          selected[j].textContent = mappedSelected;
        }
      }
    }

    mobileMq.addEventListener('change', placeCurrencyWidget);

    var headerEl = document.getElementById('header-component');
    if (headerEl) {
      new MutationObserver(placeCurrencyWidget).observe(headerEl, {
        attributes: true,
        attributeFilter: ['data-menu-style'],
      });
    }

    var observer = new MutationObserver(function () {
      placeCurrencyWidget();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeCurrencyWidget);
    } else {
      placeCurrencyWidget();
    }

    // GOTCHA (2026-07-06, canlıda gözlendi): BUCKS SDK gerçek MOBİL UA'da ilk
    // yüklemede wrapper'ı HİÇ mount etmeyebiliyor (masaüstü UA'da sorunsuz) —
    // bucksCC.rerender() çağrılınca mount ediyor ve sonraki rerender'larda kalıcı.
    // Wrapper yoksa artan aralıklarla birkaç kez dürt; mount olunca (veya app
    // gerçekten kapalıysa 5 denemede) durur. Desktop'ta no-op.
    var bucksNudges = 0;
    function nudgeBucks() {
      if (document.querySelector('.buckscc-currency-wrapper')) return;
      if (window.bucksCC && typeof window.bucksCC.rerender === 'function') {
        try { window.bucksCC.rerender(); } catch (e) { /* app hazır değil */ }
      }
      bucksNudges += 1;
      if (bucksNudges < 5) setTimeout(nudgeBucks, 900 * bucksNudges);
    }
    setTimeout(nudgeBucks, 800);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joven-grid-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jgc-carousel')) {
    customElements.define(
      'jgc-carousel',
      class JgcCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.jgc__track');
          this.prev = this.querySelector('.jgc__arrow--prev');
          this.next = this.querySelector('.jgc__arrow--next');
          if (!this.track) return;

          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.update());
            this.ro.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.update());
          }
          this.update();
        }

        disconnectedCallback() {
          this.ro && this.ro.disconnect();
        }

        page(dir) {
          // advance exactly ONE item (item width + gap)
          const item = this.track.querySelector('.jgc__item');
          let step = this.track.clientWidth * 0.9;
          if (item) {
            const cs = getComputedStyle(this.track);
            const gap = parseFloat(cs.columnGap || cs.gap) || 0;
            step = item.getBoundingClientRect().width + gap;
          }
          this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
        }

        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.classList.toggle('jgc__carousel--no-scroll', max <= 2);
          if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
          if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joven-ultimate-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jub-carousel')) {
    customElements.define(
      'jub-carousel',
      class JubCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.jub__track');
          this.prev = this.querySelector('.jub__arrow--prev');
          this.next = this.querySelector('.jub__arrow--next');
          this.timer = null;

          if (!this.track) return;

          this.prev && this.prev.addEventListener('click', () => {
            this.page(-1);
            this.resetAutoplay();
          });
          
          this.next && this.next.addEventListener('click', () => {
            this.page(1);
            this.resetAutoplay();
          });

          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.update());
            this.ro.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.update());
          }

          this.update();
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.ro && this.ro.disconnect();
          this.stopAutoplay();
        }

        page(dir) {
          const item = this.track.querySelector('.jub__item');
          let step = this.track.clientWidth * 0.9;
          if (item) {
            const cs = getComputedStyle(this.track);
            const gap = parseFloat(cs.columnGap || cs.gap) || 0;
            step = item.getBoundingClientRect().width + gap;
          }

          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          
          if (dir === 1 && this.track.scrollLeft >= maxScroll - 5) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } 
          else if (dir === -1 && this.track.scrollLeft <= 5) {
            this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          } 
          else {
            this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
          }
        }

        startAutoplay() {
          const isAutoplay = this.dataset.autoplay === 'true';
          const speed = parseInt(this.dataset.speed, 10) || 5000;

          if (!isAutoplay || this.timer) return;

          this.timer = setInterval(() => {
            this.page(1);
          }, speed);
        }

        stopAutoplay() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        resetAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
        }

        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.classList.toggle('jub__carousel--no-scroll', max <= 2);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joven-recently-viewed')) {
    customElements.define('joven-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.storageKey || 'joven:recently-viewed';
        this.setupArrows();
        this.load();
        if (this.key === 'joven:favorites') {
          this.onFavoriteToggled = () => this.load();
          document.addEventListener('joven:favorite-toggled', this.onFavoriteToggled);
        }
      }
      disconnectedCallback() {
        if (this.onFavoriteToggled) {
          document.removeEventListener('joven:favorite-toggled', this.onFavoriteToggled);
        }
        if (this.onScroll) {
          window.removeEventListener('resize', this.onScroll);
        }
      }
      /*
       * product-list carousel'iyle aynı ok davranışı: bir tık = bir "sayfa"
       * (görünen alan + boşluk), uçtaki ok disabled → CSS ile gizlenir.
       */
      setupArrows() {
        const viewport = this.querySelector('.jrv-strip__viewport');
        const track = this.querySelector('.jrv-strip__track');
        if (!viewport || !track) return;
        this.track = track;
        this.prevBtn = viewport.querySelector('.slideshow-control--previous');
        this.nextBtn = viewport.querySelector('.slideshow-control--next');
        const pageSize = () => {
          const cs = getComputedStyle(track);
          const inner = track.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
          return inner + (parseFloat(cs.columnGap) || 0);
        };
        const go = (dir) => track.scrollBy({ left: dir * pageSize(), behavior: 'smooth' });
        this.prevBtn?.addEventListener('click', (e) => { e.preventDefault(); go(-1); });
        this.nextBtn?.addEventListener('click', (e) => { e.preventDefault(); go(1); });
        this.onScroll = () => this.syncArrows();
        track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.syncArrows();
      }
      syncArrows() {
        const track = this.track;
        if (!track) return;
        const max = track.scrollWidth - track.clientWidth;
        const noScroll = max <= 1;
        this.prevBtn?.toggleAttribute('disabled', noScroll || track.scrollLeft <= 1);
        this.nextBtn?.toggleAttribute('disabled', noScroll || track.scrollLeft >= max - 1);
      }
      async load() {
        try {
          await this.render();
        } finally {
          this.syncArrows();
          // Mobil nokta göstergesi (joven-carousel-dots) kartlar geldikten
          // sonra yeniden kurulsun.
          document.dispatchEvent(new CustomEvent('joven:strip-updated'));
        }
      }
      async render() {
        const sectionId = this.dataset.sectionId;
        const limit = parseInt(this.dataset.limit || '4', 10);
        const exclude = this.dataset.exclude || '';
        const designMode = this.dataset.designMode === '1';
        const emptyText = this.dataset.emptyText || '';
        const track = this.querySelector('.jrv-strip__track');
        const emptyEl = this.querySelector('.jrv-strip__empty');
        const heading = this.closest('.section-resource-list')?.querySelector('.section-resource-list__content');
        if (!track || !sectionId) return;

        let handles = [];
        try { handles = JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { handles = []; }
        handles = handles.filter((h) => h && h !== exclude).slice(0, limit);

        const cardFrom = (root) => {
          const tpl = root.getElementById('rv-card-source-' + sectionId);
          if (!tpl) return null;
          const holder = document.createElement('div');
          holder.innerHTML = tpl.innerHTML;
          return holder.querySelector('product-card');
        };
        const li = (card) => {
          const el = document.createElement('li');
          el.className = 'resource-list__item';
          el.appendChild(card);
          return el.outerHTML;
        };

        if (!handles.length) {
          track.innerHTML = '';
          if (designMode) {
            const card = cardFrom(document);
            if (card) {
              const items = [];
              for (let i = 0; i < limit; i++) items.push(li(card.cloneNode(true)));
              track.innerHTML = items.join('');
              if (emptyEl) emptyEl.setAttribute('hidden', '');
              this.removeAttribute('hidden');
              if (heading) heading.removeAttribute('hidden');
            }
            return;
          }
          if (emptyText && emptyEl) {
            emptyEl.textContent = emptyText;
            emptyEl.removeAttribute('hidden');
            this.removeAttribute('hidden');
            if (heading) heading.removeAttribute('hidden');
          } else {
            this.setAttribute('hidden', '');
            if (heading) heading.setAttribute('hidden', '');
          }
          return;
        }

        const results = await Promise.all(handles.map(async (h) => {
          try {
            const res = await fetch('/products/' + encodeURIComponent(h) + '?section_id=' + encodeURIComponent(sectionId), {
              headers: { 'X-Requested-With': 'fetch' }
            });
            if (!res.ok) return null;
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const card = cardFrom(doc);
            return card ? li(card) : null;
          } catch (e) { return null; }
        }));

        const valid = results.filter(Boolean);
        if (!valid.length) {
          if (emptyText && emptyEl) {
            track.innerHTML = '';
            emptyEl.textContent = emptyText;
            emptyEl.removeAttribute('hidden');
            this.removeAttribute('hidden');
            if (heading) heading.removeAttribute('hidden');
          } else {
            this.setAttribute('hidden', '');
            if (heading) heading.setAttribute('hidden', '');
          }
          return;
        }
        if (emptyEl) emptyEl.setAttribute('hidden', '');
        track.innerHTML = valid.join('');
        this.removeAttribute('hidden');
        if (heading) heading.removeAttribute('hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
